import { render, staticRenderFns } from "./SGPLoadingComponent.vue?vue&type=template&id=3b488e38"
import script from "./SGPLoadingComponent.vue?vue&type=script&lang=js"
export * from "./SGPLoadingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports